/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
import { useEffect } from 'react'
import _get from 'lodash/get'
import useWindow from '@hooks/useWindow'
import { saveLocalStorage, getFromBrowserStorage } from '@helpers/storage'
import { isEmpty } from 'lodash'
import * as FingerprintJS from '@fingerprintjs/fingerprintjs-pro'
import { identifyFingerprint } from '@components/integrations/Segment'
import shouldTrackUser from '../Util/shouldTrackUser'

const FINGERPRINT_LOCALSTORAGE_ID = 'fingerprint_id'

export const Fingerprint = () => {
  const { pushToDataLayer, checkProperty } = useWindow()

  const FP_API_KEY = process.env.GATSBY_FINGERPRINT_API_KEY
  const FPJS_AGENT_DOWNLOAD_PATH = process.env.GATSBY_FPJS_AGENT_DOWNLOAD_PATH
  const FPJS_BEHAVIOR_PATH = process.env.GATSBY_FPJS_BEHAVIOR_PATH
  const FPJS_GET_RESULT_PATH = process.env.GATSBY_FPJS_GET_RESULT_PATH
  const FPJS_PROXY_URL = process.env.GATSBY_FPJS_PROXY_URL

  useEffect(() => {
    const initFingerPrint = async () => {
      try {
        let fingerprintId = getFingerprintId()
        const trackable = await shouldTrackUser()
        if (!trackable.isTrackable) {
          throw new Error(`User is not trackable: ${JSON.stringify(trackable)}`)
        }
        if (isEmpty(fingerprintId)) {
          const baseUrl = `${FPJS_PROXY_URL}/${FPJS_BEHAVIOR_PATH}`
          const fingerprintOptions = {
            endpoint: [`${baseUrl}/${FPJS_GET_RESULT_PATH}?region=us`, FingerprintJS.defaultEndpoint],
            apiKey: FP_API_KEY,
            scriptUrlPattern: [
              `${baseUrl}/${FPJS_AGENT_DOWNLOAD_PATH}?apiKey=${FP_API_KEY}&version=3&loaderVersion=3.8.3`,
              FingerprintJS.defaultScriptUrlPattern,
            ],
          }
          const fingerPrint = await FingerprintJS.load(fingerprintOptions)
          const result = await fingerPrint.get()
          const { visitorId } = result
          fingerprintId = visitorId
          saveLocalStorage(FINGERPRINT_LOCALSTORAGE_ID, fingerprintId)
        }
        checkProperty('analytics')
          .then(() => identifyFingerprint(fingerprintId))
          .catch(err => {
            console.log('Analytics failed to start.', err.message)
          })

        pushToDataLayer({ event: 'fingerprint.loaded', data: { fingerprintId } })
      } catch (error) {
        console.log(`Loading Fingerprint failed. ${error.message}`)
        identifyFingerprint()
      }
    }
    initFingerPrint()
  }, [])

  return null
}

export const getFingerprintId = () => getFromBrowserStorage('local', FINGERPRINT_LOCALSTORAGE_ID)
